import toSnake from "./toSnake.mjs";
export default (x) => toSnake(x).split('_').map(([a, ...w]) => [(a || '').toUpperCase(), ...w].join('')).join(' ');
//# sourceMappingURL=toTitle.mjs.map